/**
 * A Danish time's translation (15/10/2026): the country minute the planner
 * puts it on, after the country's flag — "🇦🇺 18:00". The minute comes from
 * the timing mirror (the planner's own conversion), never re-derived here.
 * For Media Devoted | Created By Ciro Autiero
 */
import { FC } from 'react';

import { minutesLabel } from '../../../utils/format';
import { ClockLabel } from './ClockLabel';
import { useCountryClock } from './country-clock-context';

interface Props {
  /** The country's minute (may exceed 1439 = the next day); null = nothing to show. */
  min: number | null;
  className?: string;
  /** The day mark as a small raised tag (dense rows). */
  compact?: boolean;
}

export const CountryEcho: FC<Props> = ({ min, className, compact = false }) => {
  const { flag, tz } = useCountryClock();
  if (min === null) return null;
  return (
    <span
      className={`font-mono text-[11px] tabular-nums text-muted-foreground ${className ?? ''}`}
      title={tz ? 'The same moment on the country’s clock — it moves when either country changes its clocks' : 'The country has no timezone yet — Danish time is used as it is'}
      data-testid="country-echo"
    >
      {flag} {compact ? <ClockLabel label={minutesLabel(min)} /> : minutesLabel(min)}
    </span>
  );
};
